'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/eval.js
// module id = 242
// module chunks = 0 15 16 17 18